import { LoadState } from "../../constants/enums";

export interface ILeadsState {
	list: {
		list: ILead[];
		totalRecords: number;
		loading: LoadState;
		error: string | null;
	};
	lead: {
		data: ILead;
		loading: LoadState;
		error: string | null;
	};
}

export interface ILead {
	leads_unique_id: number;
	leads_uuid: string;
	leads_code: string;
	inquiry_date: Date;
	course_duration: string;
	organizations_uuid: string;
	organizations_name: string;
	courses_uuid: string;
	courses_name: string;
	batch: string;
	session_uuid: string;
	customer_name: string;
	academic_year: number;
	date_of_birth: string;
	gender: string;
	caste_category: string | null;
	seat_confirmation_fee: string | null;
	permanent_address: string | null;
	city: string;
	state: string;
	pincode: string;
	country: string;
	contact_no: string;
	alternate_contact_no: string | null;
	email_id: string;
	remarks: string | null;
	inquiry_reference: string | null;
	followUp_date_and_remark: string;
	hostel_required: string;
	father_name: string | null;
	mother_name: string | null;
	parents_contact_no: string;
	annual_income: string | null;
	course_fee_structure: string | null;
	assigned_to_id: number;
	assigned_to_code: string | null;
	assigned_to_name: string | null;
	status: string;
	created_by_uuid: string | null;
	created_by_name: string | null;
	modified_by_uuid: string | null;
	modified_by_name: string | null;
	create_ts: string;
	insert_ts: string;
}

export interface IDocumentPdf {
	pdfType: string;
	isPreview: boolean;
	uuids: string[];
}

export interface IStudentReportPdf {
	pdfType: string;
	isPreview: boolean;
	organizations_uuid: string;
	courses_uuid: string;
	batch: string;
}

export const DefaultDocumentPdf: IDocumentPdf = {
	pdfType: "",
	isPreview: false,
	uuids: [],
};

export const initialLead: ILead = {
	leads_unique_id: 0,
	leads_uuid: "",
	leads_code: "",
	course_duration: "",
	inquiry_date: new Date(),
	organizations_uuid: "",
	organizations_name: "",
	batch: "",
	academic_year: 0,
	courses_uuid: "",
	courses_name: "",
	session_uuid: "",
	customer_name: "",
	date_of_birth: "",
	gender: "",
	caste_category: null,
	seat_confirmation_fee: null,
	permanent_address: null,
	city: "",
	state: "",
	pincode: "",
	country: "",
	contact_no: "",
	alternate_contact_no: null,
	email_id: "",
	remarks: null,
	inquiry_reference: null,
	followUp_date_and_remark: "",
	hostel_required: "",
	father_name: null,
	mother_name: null,
	parents_contact_no: "",
	annual_income: null,
	course_fee_structure: "",
	assigned_to_id: 0,
	assigned_to_code: null,
	assigned_to_name: null,
	status: "ACTIVE",
	created_by_uuid: null,
	created_by_name: null,
	modified_by_uuid: null,
	modified_by_name: null,
	create_ts: "",
	insert_ts: "",
};

export const initialLeadState: ILeadsState = {
	list: {
		list: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	lead: {
		data: initialLead,
		loading: LoadState.NotLoaded,
		error: null,
	},
};
